// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import TextBlock from './TextBlock';
import Button from './Button';

const SidebarLayout = styled.div`
  display: grid;
  grid-template-rows: min-content 1fr;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

const SidebarHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-column-gap: 8px;
  align-items: flex-start;
  padding: 16px 24px;
  border-bottom: ${colors.silt} solid 1px;
`;

const HeaderTitleText = styled(TextBlock)`
  padding: 4px 0;
`;

const SidebarBody = styled.div`
  overflow: auto;
  position: relative;
`;

type SidebarProps = {
  children: Node,
  dismiss: () => void,
  headerContent: Node,
};

/**
 * Represents the generic styled sidebar layout
 */
const Sidebar = ({ children, dismiss, headerContent }: SidebarProps) => (
  <SidebarLayout>
    <SidebarHeader>
      {typeof headerContent === 'string' ? (
        <HeaderTitleText styleType="largeBold">{headerContent}</HeaderTitleText>
      ) : (
        headerContent
      )}

      <Button icon="close" styleType="total-ghost" onClick={dismiss} />
    </SidebarHeader>
    <SidebarBody>{children}</SidebarBody>
  </SidebarLayout>
);

export default Sidebar;
